import React, { useContext } from 'react'
import { Button } from '@/components/atoms'
import { ButtonType } from '@/components/atoms/button'
import { css } from '@emotion/core'
import { RadioGroupField, RadioGroupProps } from '../radio-group-field'
import { useErrorHandler } from '@/hooks/use-error-handler'
import { LoaderContextCreator } from '@/contexts/loader'
import { enabledSubjectSelectTypes, storeSearchSubjectHistory } from '@/models/report'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '@/features/hooks'
import { exportReportAsync, fetchReportHistory } from '@/features/report-manager/report-manager-thunks'

type Prop = { onSubmit: any }
export const FormContainer: React.FC<Prop> = ({ children, ...prop }) => {
  const { t } = useTranslation()
  const { errorHandler } = useErrorHandler()
  const { setIsLoading } = useContext(LoaderContextCreator())
  const dispatch = useAppDispatch()

  const doExport = async formValue => {
    try {
      const isRequiredSubject = enabledSubjectSelectTypes.includes(formValue.type)
      if (isRequiredSubject && !formValue.subjectCodes.length) {
        alert(t('Please select subjects'))
        return
      }

      setIsLoading(true)
      storeSearchSubjectHistory(formValue.type, formValue.subjectCodes)
      await dispatch(exportReportAsync(formValue)).unwrap()
      dispatch(fetchReportHistory())
    } catch (error) {
      errorHandler(error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div css={componentStyle}>
      {children}
      <div className="footer">
        <Button
          icon={require('@/static/images/download_white.svg')}
          buttonType={ButtonType.Primary}
          width={150}
          height={38}
          onClick={prop.onSubmit(doExport)}
        >
          レポート作成
        </Button>
      </div>
    </div>
  )
}

export const FormInputBlock: React.FC<{ title?: string }> = ({ children, ...prop }) => {
  return (
    <div css={formInputBlockStyle}>
      <div className="title">{prop.title}</div>
      <div className="input">{children}</div>
    </div>
  )
}
export const AdditionalFormInputBlock: React.FC = ({ children }) => {
  return <div css={additionalFormInputBlockStyle}>{children}</div>
}

export const FormInputRadioWrapper: React.FC<RadioGroupProps<string>> = prop => {
  return (
    <RadioGroupField
      value={prop.value}
      items={prop.items as any}
      onChange={prop.onChange}
      itemCss={css({ marginRight: 32 })}
      style={{ radioSize: 18, labelMargin: 14 }}
    />
  )
}

const componentStyle = css({
  width: '100%',
  height: '100%',
  background: '#FFF',
  boxShadow: '0px 0px 6px #0000001a',
  borderRadius: 5,
  padding: 32,
  '.footer': { paddingTop: 24 },
})

const formInputBlockStyle = css({
  paddingTop: 24,
  ':first-of-type': { paddingTop: 0 },
  '.title': {
    marginBottom: 11,
    color: '#676767',
    fontSize: 12,
    letterSpacing: 0.6,
    fontWeight: 'bold',
  },
})

const additionalFormInputBlockStyle = css({
  padding: 24,
  marginTop: 24,
  background: '#fafafa',
  borderRadius: 5,
  border: '1px solid #f2f2f2',
})
